var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count > 0)?_c('div',{staticClass:"rounded-full",class:_vm.styles,domProps:{"textContent":_vm._s(_vm.count)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }